import dispatcher from "./Dispatcher";

export const CONSTANT = {
    GET_RANDOM_RESPONSE: 'GET_RANDOM_RESPONSE',
    GET_RANDOM: 'GET_RANDOM',
    SHOW_TOAST: 'SHOW_TOAST'
};

export function handleActions(response) {
    dispatcher.dispatch({
        actionType: CONSTANT.GET_RANDOM_RESPONSE,
        response: response
    })
  
}

export function showToast(response) {
    dispatcher.dispatch({
        actionType: CONSTANT.SHOW_TOAST,
        response: response
    })
  
}


// WEBPACK FOOTER //
// ./src/pages/Actions.js